export const getImageRatio = (width: number, height: number) =>
  width && height ? width / height : null;

export const isRatioInTolerance = (
  imageRatio: number | null,
  expectedImageRatio: number | null,
  tolerance = 0.1
) =>
  Math.abs((expectedImageRatio || 0) - (imageRatio || 0)) <=
  (expectedImageRatio || 0) * tolerance;
